
import { Outlet } from 'react-router-dom';

import Header from './partials/Header';
import Footer from './partials/Footer';

export default function BasePageLayout({ pageClassname = '' }) {
    return (<site-wrapper class={(pageClassname === '') ? null : pageClassname}>
        <Header />
        <hr className="header-divider"/>
        <main className="main-content" role="main">
            <Outlet />
        </main>
        <Footer />
    </site-wrapper>)
}
